export default __webpack_public_path__ + "static/media/exam-return-icon.f01b2657.svg";